import React from "react";
import InfoSection from "./info-section";
import { A } from 'hookrouter';
import { useTranslation } from 'react-i18next';
import { teacherCompensationTypeOptions, translateOptionValue } from '../../../../components/exl/shared/translations';
import { ACTIVE, GENERAL_TEACHER_INFO_COMP_TYPE_LABEL, GENERAL_TEACHER_INFO_EMAIL_LABEL, GENERAL_TEACHER_INFO_NAME_LABEL, GENERAL_TEACHER_INFO_STATUS_LABEL, INACTIVE } from "../../../../i18n/keyConstants";


export default function GeneralTeacherInformation({ teacher, teacherUser }) {

    const {
        name,
        email,
        compensationType,
        isActive
    } = teacher;
    const { t } = useTranslation(['generalTeacherInformation', 'shared']);
    return (
        <div style={{ display: "flex", flexWrap: "wrap" }}>
            <InfoSection sectionLabel={t(GENERAL_TEACHER_INFO_NAME_LABEL)}>
                {teacher.coaEmpId ?
                    <A href={`/employee/${teacher.coaEmpId}/info`}>
                        {name}
                    </A>
                    :
                    <>{name} [EXTERNAL]</>
                }
            </InfoSection>

            <InfoSection sectionLabel={t(GENERAL_TEACHER_INFO_EMAIL_LABEL)}>
                {email}
            </InfoSection>

            {teacherUser && teacherUser.compensationTypePermission && (
                <InfoSection sectionLabel={t(GENERAL_TEACHER_INFO_COMP_TYPE_LABEL)}>
                    {t(translateOptionValue(compensationType, teacherCompensationTypeOptions), { ns: 'shared' })}
                </InfoSection>
            )}

            <InfoSection sectionLabel={t(GENERAL_TEACHER_INFO_STATUS_LABEL)}>
                {isActive ? t(ACTIVE, { ns: 'shared' }) : t(INACTIVE, { ns: 'shared' })}
            </InfoSection>
        </div>
    )
}